import { Language, Voice } from '../models/voice.model';

export const AVAILABLE_LANGUAGES: Language[] = [
  { name: '🇺🇸 Spanish (Neutral USA)', code: 'es-US' },
  { name: '🇪🇸 Spanish (Spain)', code: 'es-ES' },
  { name: '🇺🇸 English (United States)', code: 'en-US' },
  { name: '🇬🇧 English (United Kingdom)', code: 'en-GB' },
  { name: '🇦🇺 English (Australia)', code: 'en-AU' },
  { name: '🇮🇳 English (India)', code: 'en-IN' },

  { name: '🇧🇷 Portuguese (Brazil)', code: 'pt-BR' },
  { name: '🇵🇹 Portuguese (Portugal)', code: 'pt-PT' },
  { name: '🇯🇵 Japanese (Japan)', code: 'ja-JP' },

  { name: '🇿🇦 Afrikaans (South Africa)', code: 'af-ZA' },
  { name: '🇪🇹 Amharic (Ethiopia)', code: 'am-ET' },
  { name: '🏳️ Arabic (Generic)', code: 'ar-XA' },
  { name: '🇧🇬 Bulgarian (Bulgaria)', code: 'bg-BG' },
  { name: '🇮🇳 Bengali (India)', code: 'bn-IN' },
  { name: '🇪🇸 Catalan (Spain)', code: 'ca-ES' },
  { name: '🇨🇳 Chinese, Mandarin (China)', code: 'cmn-CN' },
  { name: '🇹🇼 Chinese, Mandarin (Taiwan)', code: 'cmn-TW' },
  { name: '🇨🇿 Czech (Czech Republic)', code: 'cs-CZ' },
  { name: '🇩🇰 Danish (Denmark)', code: 'da-DK' },
  { name: '🇩🇪 German (Germany)', code: 'de-DE' },
  { name: '🇬🇷 Greek (Greece)', code: 'el-GR' },

  { name: '🇪🇪 Estonian (Estonia)', code: 'et-EE' },
  { name: '🇪🇸 Basque (Spain)', code: 'eu-ES' },
  { name: '🇫🇮 Finnish (Finland)', code: 'fi-FI' },
  { name: '🇵🇭 Filipino (Philippines)', code: 'fil-PH' },
  { name: '🇨🇦 French (Canada)', code: 'fr-CA' },
  { name: '🇫🇷 French (France)', code: 'fr-FR' },
  { name: '🇪🇸 Galician (Spain)', code: 'gl-ES' },
  { name: '🇮🇳 Gujarati (India)', code: 'gu-IN' },
  { name: '🇮🇱 Hebrew (Israel)', code: 'he-IL' },
  { name: '🇮🇳 Hindi (India)', code: 'hi-IN' },
  { name: '🇭🇺 Hungarian (Hungary)', code: 'hu-HU' },
  { name: '🇮🇩 Indonesian (Indonesia)', code: 'id-ID' },
  { name: '🇮🇸 Icelandic (Iceland)', code: 'is-IS' },
  { name: '🇮🇹 Italian (Italy)', code: 'it-IT' },
  { name: '🇮🇳 Kannada (India)', code: 'kn-IN' },
  { name: '🇰🇷 Korean (South Korea)', code: 'ko-KR' },
  { name: '🇱🇹 Lithuanian (Lithuania)', code: 'lt-LT' },
  { name: '🇱🇻 Latvian (Latvia)', code: 'lv-LV' },
  { name: '🇮🇳 Malayalam (India)', code: 'ml-IN' },
  { name: '🇮🇳 Marathi (India)', code: 'mr-IN' },
  { name: '🇲🇾 Malay (Malaysia)', code: 'ms-MY' },
  { name: '🇳🇴 Norwegian Bokmål (Norway)', code: 'nb-NO' },
  { name: '🇧🇪 Dutch (Belgium)', code: 'nl-BE' },
  { name: '🇳🇱 Dutch (Netherlands)', code: 'nl-NL' },
  { name: '🇮🇳 Punjabi (India)', code: 'pa-IN' },
  { name: '🇵🇱 Polish (Poland)', code: 'pl-PL' },

  { name: '🇷🇴 Romanian (Romania)', code: 'ro-RO' },
  { name: '🇷🇺 Russian (Russia)', code: 'ru-RU' },
  { name: '🇸🇰 Slovak (Slovakia)', code: 'sk-SK' },
  { name: '🇷🇸 Serbian (Serbia)', code: 'sr-RS' },
  { name: '🇸🇪 Swedish (Sweden)', code: 'sv-SE' },
  { name: '🇰🇪 Swahili (Kenya)', code: 'sw-KE' },
  { name: '🇮🇳 Tamil (India)', code: 'ta-IN' },
  { name: '🇮🇳 Telugu (India)', code: 'te-IN' },
  { name: '🇹🇭 Thai (Thailand)', code: 'th-TH' },
  { name: '🇹🇷 Turkish (Turkey)', code: 'tr-TR' },
  { name: '🇺🇦 Ukrainian (Ukraine)', code: 'uk-UA' },
  { name: '🇮🇳 Urdu (India)', code: 'ur-IN' },
  { name: '🇻🇳 Vietnamese (Vietnam)', code: 'vi-VN' },
  { name: '🇭🇰 Chinese, Cantonese (Hong Kong)', code: 'yue-HK' },
];

export const VOICES: Voice[] = [
  // Female voices
  { name: '♀️ Aoede 👱🏻‍♀️', id: 'aoede' },
  { name: '♀️ Kore 👱🏻‍♀️', id: 'kore' },
  { name: '♀️ Leda 👱🏻‍♀️', id: 'leda' },
  { name: '♀️ Zephyr 👱🏻‍♀️', id: 'zephyr' },
  { name: '♀️ Autonoe 👱🏻‍♀️', id: 'autonoe' },
  { name: '♀️ Callirrhoe 👱🏻‍♀️', id: 'callirrhoe' },
  { name: '♀️ Despina 👱🏻‍♀️', id: 'despina' },
  { name: '♀️ Erinome 👱🏻‍♀️', id: 'erinome' },
  { name: '♀️ Gacrux 👱🏻‍♀️', id: 'gacrux' },
  { name: '♀️ Laomedeia 👱🏻‍♀️', id: 'laomedeia' },
  { name: '♀️ Pulcherrima 👱🏻‍♀️', id: 'pulcherrima' },
  { name: '♀️ Sulafat 👱🏻‍♀️', id: 'sulafat' },
  { name: '♀️ Vindemiatrix 👱🏻‍♀️', id: 'vindemiatrix' },
  { name: '♀️ Achernar 👱🏻‍♀️', id: 'achernar' },

  // Male voices
  { name: '♂️ Puck 🧔🏻‍♂️', id: 'puck' },
  { name: '♂️ Charon 🧔🏻‍♂️', id: 'charon' },
  { name: '♂️ Fenrir 🧔🏻‍♂️', id: 'fenrir' },
  { name: '♂️ Orus 🧔🏻‍♂️', id: 'orus' },
  { name: '♂️ Achird 🧔🏻‍♂️', id: 'achird' },
  { name: '♂️ Algenib 🧔🏻‍♂️', id: 'agenib' },
  { name: '♂️ Algieba 🧔🏻‍♂️', id: 'algieba' },
  { name: '♂️ Alnilam 🧔🏻‍♂️', id: 'alnilam' },
  { name: '♂️ Enceladus 🧔🏻‍♂️', id: 'enceladus' },
  { name: '♂️ Iapetus 🧔🏻‍♂️', id: 'iapetus' },
  { name: '♂️ Rasalgethi 🧔🏻‍♂️', id: 'rasalgethi' },
  { name: '♂️ Sadachbia 🧔🏻‍♂️', id: 'sadachbia' },
  { name: '♂️ Sadaltager 🧔🏻‍♂️', id: 'sadaltager' },
  { name: '♂️ Schedar 🧔🏻‍♂️', id: 'schedar' },
  { name: '♂️ Umbriel 🧔🏻‍♂️', id: 'umbriel' },
  { name: '♂️ Zubenelgenubi 🧔🏻‍♂️', id: 'zubenelgenubi' },
];
